import {
    QuestionCircleOutlined,
    CustomerServiceOutlined,
  } from '@ant-design/icons';
  import { APP_PREFIX_PATH } from 'configs/AppConfig'
  import book from '../../menus/icons/book.js'

let AdminModuloAyuda = [
  {
    key: "Ayuda",
    path: `${APP_PREFIX_PATH}/pages`,
    title: "sidenav.ayuda.ayuda",
    icon: QuestionCircleOutlined,
    breadcrumb: true,
    permission:['show'],
    submenu: [
      {
        key: "ayuda-preguntas",
        path: `${APP_PREFIX_PATH}/pages/preguntas`,
        title: "sidenav.ayuda.faq",
        icon: QuestionCircleOutlined,
        breadcrumb: true,
        permission:['show'],
        submenu: [],
      },
      {
        key: "ayuda-soporte",
        path: `${APP_PREFIX_PATH}/pages/soporte`,
        title: "sidenav.ayuda.soporte",
        icon: CustomerServiceOutlined,
        breadcrumb: true,
        permission:['show'],
        submenu: [],
      },
      {
        key: "ayuda-manuales",
        path: `${APP_PREFIX_PATH}/pages/manuales`,
        title: "sidenav.ayuda.manual",
        icon: book,
        breadcrumb: true,
        permission:['show'],
        submenu: [],
      },
    ],
  },
];

export default AdminModuloAyuda;
